import { render, staticRenderFns } from "./ResultList.vue?vue&type=template&id=57bb4ce3&scoped=true&"
import script from "./ResultList.vue?vue&type=script&lang=js&"
export * from "./ResultList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bb4ce3",
  null
  
)

export default component.exports